import { Button, Grid, TextareaAutosize } from "@mui/material";
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import React, { useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TwoInputField from "../../../components/TwoInputField";
import SingleInputField from "../../../components/SingleInputField";

import { campusData } from "../../../assets/lib/campus";
import { CircularLoader } from "../../../components/widgets/CircularLoader";
import { ErrorText } from "../../../components";
import { useMediaQuery } from "@mui/material";

const customStyle = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    fontFamily: "Montserrat, sans-serif",
    backgroundColor: "#fff",
    color: "#000",
  },

  formContainer: {
    padding: "10px 40px 40px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flexGrow: "1",
    overflowY: "scroll",
  },

  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  formLabel: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#000",
  },

  formInput: {
    padding: "16px",
    border: "1px solid #d1d1d1",
    borderRadius: "4px",
    fontSize: "16px",
    fontFamily: "Montserrat, sans-serif",
    color: "#000",
    backgroundColor: "#fff",
  },

  topForm: {
    display: "flex",
  },

  heading: {
    margin: 0,
    fontSize: "22px",
    marginTop: "5px",
    paddingBottom: "6px",
    borderBottom: "1px solid #000",
    fontWeight: 600,
  },

  actionBtn: {
    display: "flex",
    justifyContent: "end",
  },

  editBtn: {
    display: "flex",
    padding: "10px 40px 5px",
    justifyContent: "end",
  },

  imgbtn: {
    backgroundColor: "#000 !important",
    color: "#fff !important",
    fontFamily: "Montserrat, sans-serif",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#222 !important",
    },
  },

  "@media (max-width: 390px)": {
    formContainer: { padding: "5px 5px", gap: "5px" },
    formInput: { padding: "5px", fontSize: "10px" },
    heading: { fontSize: "18px" },
    imgbtn: { fontSize: "6px", marginLeft: "-10px", marginTop: "15px" },
  },
});

const Layout = (props) => {
  const {
    isEdit, setIsEdit, isNewAdd, getCampusInput, campusState,
    handleSubmitModal, errorFields, fetchLoading, submitLoading,
    errorOnFetch, onFileUpload, onImageUpload,
    updateAdminField, addAdmin, removeAdmin, toggleDisableAdmin
  } = props;

  const classes = customStyle();
  const isPhone = useMediaQuery("(max-width: 390px)");

  const [uploadedFileName, setUploadedFileName] = useState("");
  const [uploadedImageName, setUploadedImageName] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFileName(file.name);
      onFileUpload(file);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedImageName(file.name);
      onImageUpload(file);
    }
  };

  return fetchLoading ? (
    <CircularLoader />
  ) : errorOnFetch ? (
    <ErrorText />
  ) : (
    <div className={classes.root}>
      {submitLoading && <CircularLoader isPoistionAbsolute />}

      {!isNewAdd && !isEdit && (
        <div className={classes.editBtn}>
          <Button
            variant="outlined"
            style={{
              padding: "10px 24px",
              borderRadius: "10px",
              borderColor: "#000",
              color: "#000",
              fontFamily: "Montserrat, sans-serif",
            }}
            onClick={() => setIsEdit(true)}
          >
            <span className="flex align-items-center">
              <EditIcon /> Edit Page
            </span>
          </Button>
        </div>
      )}

      <div className={classes.formContainer}>
        <h3 className={classes.heading}>Campus Details</h3>

        <div className={classes.topForm}>
          <div className="width-80-per">
            <TwoInputField
              content={campusData.campusId}
              value={campusState.campusId}
              isEditable={false}
              secondContent={campusData.campusName}
              secondValue={campusState.campusName}
              getInputData={getCampusInput}
              errorFields={errorFields}
            />

            <TwoInputField
              content={campusData.GSTNumber}
              value={campusState.GSTNumber}
              secondContent={campusData.phoneNumber}
              secondValue={campusState.phoneNumber}
              getInputData={getCampusInput}
              errorFields={errorFields}
            />
          </div>

          <div className="width-20-per flex-direction-column pd-lt-20 align-items-center">
            <AccountCircleIcon
              sx={{ fontSize: isPhone ? "60px" : "130px", color: "#000" }}
            />

            {(isEdit || isNewAdd) && (
              <label htmlFor="upload-input">
                <Button
                  className={classes.imgbtn}
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  style={{ fontSize: "12px" }}
                >
                  Upload Image
                  <input
                    type="file"
                    id="upload-input"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  {uploadedImageName && (
                    <span style={{ marginLeft: "8px", fontSize: "12px" }}>
                      {uploadedImageName}
                    </span>
                  )}
                </Button>
              </label>
            )}
          </div>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.formGroup}>
              <span className={classes.formLabel}>
                {campusData.campusAddress.label} :
              </span>
              <TextareaAutosize
                minRows={3}
                name={campusData.campusAddress.key}
                value={campusState.campusAddress}
                onChange={getCampusInput}
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: "14px",
                  border: "1px solid #d1d1d1",
                  padding: "10px",
                }}
              />
            </div>
          </Grid>
        </Grid>
        <SingleInputField
          content={campusData.location}
          value={campusState.location}
          getInputData={getCampusInput}
          errorFields={errorFields}
          isEditable={isEdit || isNewAdd}
        />


        <h3 className={classes.heading}>Campus Admin Accounts</h3>

        {campusState.campusAdmins?.map((admin, index) => (
          <div
            key={index}
            style={{
              padding: "12px",
              border: "1px solid #d1d1d1",
              borderRadius: "8px",
              marginBottom: "10px",
              backgroundColor: admin.disabled ? "#eaeaea" : "#fff",
opacity: admin.disabled ? 0.6 : 1,


            }}
          >
            <TwoInputField
              content={{ label: "Admin Email", key: "email", type: "text" }}
              value={admin.email}
              secondContent={{ label: "Password", key: "password", type: "text" }}
              secondValue={isEdit || isNewAdd ? admin.password : "••••••"}
              getInputData={(e) => {
                if ((isEdit || isNewAdd) && !admin.disabled) {
                  updateAdminField(
                    index,
                    e.target.name === "email" ? "email" : "password",
                    e.target.value
                  );
                }
              }}
              isEditable={(isEdit || isNewAdd) && !admin.disabled}
            />

            {(isEdit || isNewAdd) && (
              <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                <Button
                  variant="outlined"
                  style={{ borderColor: "#000", color: "#000" }}
                  onClick={() => toggleDisableAdmin(index)}
                >
                  {admin.disabled ? "Enable" : "Disable"}
                </Button>

                {index > 0 && (
                  <Button
  variant="contained"
  style={{ backgroundColor: "#000", color: "#fff" }}
  onClick={() => removeAdmin(index)}
  disabled={admin.disabled}
>

                    Remove
                  </Button>
                )}
              </div>
            )}
          </div>
        ))}

        {(isEdit || isNewAdd) && (
              <Button
        variant="contained"
        style={{
          backgroundColor: "#000",
          color: "#fff",
          width: "200px",
          padding: "6px 12px",
          textTransform: "none",
        }}
        onClick={addAdmin}
      >
        + Add Another Admin
      </Button>

        )}

        <h3 className={classes.heading}>Contract Details</h3>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <div className={classes.formGroup}>
              <span className={classes.formLabel}>
                {campusData.commission.label} :
              </span>
              <input
                className={classes.formInput}
                type={campusData.commission.type}
                name={campusData.commission.key}
                value={campusState.commission}
                onChange={getCampusInput}
                disabled={!isEdit && !isNewAdd}
              />
            </div>
          </Grid>

          <Grid item xs={6}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>Documentation:</span>
              <input
                type="file"
                id="upload-doc-input"
                style={{ display: "none" }}
                onChange={handleFileChange}
                disabled={!isEdit && !isNewAdd}
              />
              {(isEdit || isNewAdd) && (
                <label htmlFor="upload-doc-input">
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#000", color: "#fff" }}
                    startIcon={<CloudUploadIcon />}
                  >
                    Upload Documents
                  </Button>
                </label>
              )}
              {uploadedFileName && <span>{uploadedFileName}</span>}
            </div>
          </Grid>
        </Grid>

        <h3 className={classes.heading}>Contact person Details</h3>

        <TwoInputField
          content={campusData.contactPersonName}
          value={campusState.contactPersonName}
          secondContent={campusData.contactPersonPhone}
          secondValue={campusState.contactPersonPhone}
          getInputData={getCampusInput}
          errorFields={errorFields}
          isEditable={isEdit || isNewAdd}
        />

        <div className={classes.actionBtn}>
          {(isEdit || isNewAdd) && (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#000",
                color: "#fff",
                minWidth: isPhone ? "140px" : "200px",
                padding: isPhone ? "8px 20px" : "12px 46px",
                borderRadius: "10px",
              }}
              onClick={handleSubmitModal}
            >
              {isEdit ? "Save Changes" : "Submit"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Layout;
